import React, { forwardRef } from 'react'
import { NavLinkProps, useLocation, useResolvedPath } from 'react-router-dom'
import { Location, Path } from 'history'
import { NavLink } from 'react-router-dom'

type TMenuLinkProps = NavLinkProps & {
  isActive?: (location: Location, path: Path) => boolean
}

const MenuLink = forwardRef<HTMLAnchorElement, TMenuLinkProps>(({ to, isActive, className: classNameProp = '', ...rest }, ref) => {
  let location = useLocation()
  let path:any = useResolvedPath(to)

  let locationPathname = location.pathname
  let toPathname = path.pathname;

  let isLinkActive = isActive ? isActive(location, path) : locationPathname.startsWith(toPathname)

  const className = [classNameProp, isLinkActive ? 'active' : null].filter(Boolean).join(' ')
  return <NavLink {...rest} ref={ref} className={className} to={to} />
})

export default MenuLink